var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainNavSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 52,
    viewBox: "0 0 375 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M720 -20V50.4736L705.232 50.426L678.69 51.8046L652.148 50.1567L625.609 50.0563L599.07 49.8609L572.527 52L545.989 50.5L519.446 50.3046L492.908 50.257L466.369 50.426L439.83 50.2782L413.291 51.6039L386.752 50.2042L360.214 51.1391L333.675 50.3521L307.133 51.3345L280.594 50.331L254.055 51.8521L227.516 50.9648L200.978 51.1866L174.439 50.1092L147.9 50.1303L121.361 51.5827L94.8225 50.6743L68.2837 49.8345L41.745 50.2306L15.2062 51.213L0 51.0176V-20H720Z",
    fill: "#E2EB76"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainNavSm);
export default __webpack_public_path__ + "static/media/main_nav_sm.887d3b05c4ca4863ae67fc5f5fd61bc1.svg";
export { ForwardRef as ReactComponent };